import React from 'react';

import {Collaborator} from 'auth/PermissionConstants';
import {SchemaPolicy} from 'auth/PolicyConstants';
import SchemaCollaboratorsSection from 'collaborator-components/SchemaCollaboratorsSection';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface SchemaWithOrgPermissionsSettingsProps {
  id?: string;
  collaborators: Array<Collaborator>;
  isReadOnly: boolean;
  description?: JSX.Element;
  onUpdate: (collaborators: Array<Collaborator>) => void;
  onSubmit?: () => Promise<void>;
  policyPredicate?: (policy: SchemaPolicy) => boolean;
}
export function SchemaWithOrgPermissionsSettings({
  id,
  collaborators,
  isReadOnly,
  description,
  onUpdate,
  onSubmit,
  policyPredicate,
}: SchemaWithOrgPermissionsSettingsProps): JSX.Element {
  return (
    <div
      className="settingsPage-contentWrapper"
      {...getTestProps({component: 'SchemaWithOrgPermissionsSettings', element: 'root'})}
    >
      <SchemaCollaboratorsSection
        policeableId={id}
        collaborators={collaborators}
        isReadOnly={isReadOnly}
        description={description}
        onUpdate={onUpdate}
        onSubmit={onSubmit}
        policyPredicate={policyPredicate}
      />
    </div>
  );
}
